import { Filter, LogicalAndFilter } from '@cubejs-client/core';

import { DEFAULT_COUNTRY_MEMBER } from './countryFilterMapping';
import { extractCubeName } from './resolveCountryFilters';

// No join path to or from any other cube, so Cube rejects a query mixing their members with another cube's.
const ISOLATED_CUBES: ReadonlySet<string> = new Set(['subnational_sales']);

const collectMembers = (filter: Filter): string[] => {
  if ('and' in filter) return filter.and.flatMap(collectMembers);
  if ('or' in filter) return filter.or.flatMap(collectMembers);
  return filter.member ? [filter.member] : [];
};

/** Keeps only the filter expressions that a query on `cubeName` can resolve. */
export const scopeFiltersToCube = (filters: LogicalAndFilter, cubeName: string): LogicalAndFilter => {
  const isIsolatedCube = ISOLATED_CUBES.has(cubeName);

  const isResolvable = (member: string): boolean => {
    const memberCube = extractCubeName(member);
    if (!isIsolatedCube) return !ISOLATED_CUBES.has(memberCube);
    // resolveCountryFilters re-targets the HCP country filter onto the cube's own country column.
    return memberCube === cubeName || member === DEFAULT_COUNTRY_MEMBER;
  };

  return { and: filters.and.filter(filterExpression => collectMembers(filterExpression).every(isResolvable)) };
};
